document.addEventListener("DOMContentLoaded", (event) => {
  if(window.location.search.includes('open-monogram=true')) {
    setTimeout(function() {
      document.querySelector('.add-monogram.modal-action').dispatchEvent(new Event('click'));
    },2000);
  }
  $('.rg-subcollections').slick({

    // normal options...
    infinite: false,
    slidesToShow: 6,

    // the magic
    responsive: [{

      breakpoint: 1700,
      settings: {
        slidesToShow: 5,
      }

    },{

      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
      }

    },,{

      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
      }

    },{

      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 3,
      }

    }, {

      breakpoint: 300,
      settings: "unslick" // destroys slick

    }]
  });
});

updateSaleSwatches();

function updateSaleSwatches() {
  if(document.querySelector('body.template--collection-sale #product-grid .cell__item')) {
    document.querySelectorAll('body.template--collection-sale #product-grid .cell__item').forEach(saleItem => {
      if(saleItem.querySelector('.card-grid-colors')) {
        //setTimeout(function() {
        updatePLPProductCardImage(saleItem.querySelector('.card-grid-colors .swatch-element:first-child'));
        //saleItem.querySelector('.card-grid-colors .swatch-element:first-child').dispatchEvent(new Event('click'));
        //},1)
      }
    })
  }
}

function updatePLPProductCardImage(button) {
  var image = button.getAttribute("data-varimg");
  var color = button.getAttribute("data-color");
  var prodId = button.getAttribute("data-prodId");
  var varId = button.getAttribute("data-varid");
  var parentSwatch = button.closest('.card--media');
  var parent = button.closest('.card-wrapper');
  parentSwatch.querySelectorAll('.swatch-element').forEach(function (el, index) {
    el.classList.remove('active');
  });
  button.classList.add('active');
  var imgElem =  parentSwatch.querySelectorAll('.image-content__image')[0];
  imgElem.src = image;
  imgElem.srcset = image;
  if ( parent.querySelector('#color-'+prodId) && parent.querySelector('#size-'+prodId) ) {
    var size = parent.querySelector('#size-'+prodId).value
    parent.querySelector('#color-'+prodId).value = color;
    /* setting variant */
    setVariantCard(parent,prodId,color,size);
  }
  const overlayLink = parent.querySelector('.overlay-link');
  if (overlayLink){
    const link = overlayLink.getAttribute('href').split('?')[0];
    parent.querySelector('.overlay-link').setAttribute('href',link+"?variant="+varId);
  }

}